import React from "react";
import {Provider} from "react-redux";
import {ThemeProvider} from "@reside/ui";
import * as Sentry from "@sentry/react";

import {store, PersistGate} from "./store";
import {AppRouter} from "./routers/AppRouter";
import {AppUpdateReload} from "./hooks/useAppUpdateReload";
import {I18nProvider} from "./atoms/i18n-provider";
import {ErrorBoundary} from "./atoms/error-boundary";
import {Alert} from "./atoms/alert";
import {DownloadManager} from "./atoms/download-manager/DownloadManager";
import {ReactQueryClientProvider} from "./atoms/react-query-client-provider";
import {NetworkStatusBanner} from "./atoms/network-status-banner";
import {AutoLogoutInfoProvider} from "./contexts/AutoLogoutInfoContext";

export const Renderer = () => (
  // skipcq: JS-0415 Validation of JSX maximum depth. This is a valid use case for a nested provider pattern.
  <Provider store={store}>
    <ReactQueryClientProvider>
      <ThemeProvider>
        <ErrorBoundary>
          <I18nProvider>
            <AutoLogoutInfoProvider>
              <AppUpdateReload />
              <NetworkStatusBanner />
              <PersistGate>
                <AppRouter />
                <Alert />
                <DownloadManager />
              </PersistGate>
            </AutoLogoutInfoProvider>
          </I18nProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </ReactQueryClientProvider>
  </Provider>
);

export const App = Sentry.withProfiler(Renderer);
